/* global jQuery, YearBook */
(function($) {

  'use strict';

/*
  const $members = $('.member');
  const $select = $('.selectpicker');

  const filterByArea = ($member, aree) => {
    return aree.length === 0 ||
        $member.is(aree.map((area) => `[data-area=${area}]`).join(','));
  };

  const filterBySettore = ($member, settori, target) => {
    if (settori.length === 0) {
      return true;
    }
    const regexp = new RegExp(`.*(?:^|-)(?:${settori.join('|')})(?:-|$).*`);
    const settoreMember = $member.data('settore');
    const match = settoreMember.match(regexp);
    /
    if (target && $(target).attr('name') === 'settore') {
      console.log(
        `%c${settoreMember} => ${regexp}`,
        `color: ${match ? 'green' : 'orange'}`
      );
    }
    /
    return match;
  };

  const filterByPartecipazione = ($member, partecipazione) => {
    return partecipazione.length === 0 || $member.is('[data-partecipazione=1]');
  };
  const isVisible = ($member, filters, target) => {
  	return filterByArea($member, filters.area) &&
      filterBySettore($member, filters.settore, target) &&
      filterByPartecipazione($member, filters.partecipazione);
  };

  $select.selectpicker({
    liveSearch: true,
    size: 10
  }).on('changed.bs.select', (event) => {
    filter(event);
  });
  

  const filter = (event) => {
    const filters = {};
    $select.each((index, select) =>
      filters[$(select).attr('name')] = $(select).val());
    
    //console.log(filters);

    let nSelected = 0;
    let nVisible = 0;
    $members.each(function() {
      const target = event ? event.target : null;
      const toShow = isVisible($(this), filters, target);
      if (toShow) {
        nSelected++;
        $(this).show().css({
          clear: nVisible && nVisible % 3 === 0 ? 'both' : 'none'
        });
        nVisible++;
      } else {
        $(this).hide().css('clear', 'none');
      }
      
    });
   
  };

  //filter();

*/


  $('.show-advertisement').on('click', function(e) {
    e.preventDefault();
    var mem = $(this).data('member');
    const $content = $('.'+mem).html();
    /*if ($advertisement.is(':visible')) {
      $('.button-text', this).html('Scopri');
    } else {
      $('.button-text', this).html('Chiudi');
    }
    //$advertisement.html($content).collapse('toggle');
    */

    $.fancybox.open({
			src  : $content,
			type : 'html',
			width  : '800px',
			opts : {
				afterShow : function( instance, current ) {
          setTimeout(function(){
          $('.fancybox-content').scrollTop(0);
          }, 1)
				}
			}
		});

    return false;
  });
  


  $(".contenuto-members").children().each(function() {
      var x = $(this).html();
      var arr = x.split('<br>');
      for (var i = arr.length - 1; i >= 0; i--) {
        arr[i] = arr[i].trim();
        arr[i] = arr[i].trim();
      }

      var html = arr.join('<br>');

      $(this).html(html);
  });



}(jQuery));
